import axios from "axios";

export default function postReimbursedCredit(payload) {
  return new Promise((resolve, reject) =>
    axios
      .post(
        "/account/system-admin/api/v1/company/user/reimbursed-credit",
        payload
      )
      .then((response) => {
        const data = response.data || {};
        if (data.success === false) {
          reject(
            data.message ||
              data.code ||
              "Reimbursed credit failed"
          );
        } else {
          resolve(response);
        }
      })
      .catch((error) => reject(error.message))
  );
}
